const sharedFontFamily =
  '"Public Sans", Roboto, "Helvetica Neue", Arial, sans-serif';

export const typography = {
  fontFamily: sharedFontFamily,
  fontWeightLight: 300,
  fontWeightRegular: 400,
  fontWeightMedium: 500,
  fontWeightSemiBold: 600,
  fontWeightBold: 700,
  h1: {
    fontFamily: sharedFontFamily,
    fontSize: '2.5rem',
    fontWeight: 700,
    lineHeight: 1.2,
  },
  h2: {
    fontFamily: sharedFontFamily,
    fontSize: '2rem',
    fontWeight: 700,
    lineHeight: 1.25,
  },
  h3: {
    fontFamily: sharedFontFamily,
    fontSize: '32px',
    fontWeight: 700,
    lineHeight: '48px',
    letterSpacing: '0',
  },
  h4: {
    fontFamily: sharedFontFamily,
    fontSize: '1.5rem',
    fontWeight: 600,
    lineHeight: 1.35,
  },
  h5: {
    fontFamily: sharedFontFamily,
    fontSize: '1.25rem',
    fontWeight: 600,
    lineHeight: 1.4,
  },
  h6: {
    fontFamily: sharedFontFamily,
    fontSize: '18px',
    fontWeight: 600,
    fontStyle: 'normal',
    lineHeight: '28px',
    letterSpacing: '0',
  },
  subtitle1: {
    fontFamily: sharedFontFamily,
    fontSize: '1rem',
    fontWeight: 500,
  },
  subtitle2: {
    fontFamily: sharedFontFamily,
    fontSize: '0.875rem',
    fontWeight: 500,
  },
  body1: {
    fontFamily: sharedFontFamily,
    fontSize: '1rem',
    fontWeight: 400,
  },
  body2: {
    fontFamily: sharedFontFamily,
    fontSize: '0.875rem',
    fontWeight: 400,
  },
  button: {
    fontFamily: sharedFontFamily,
    fontWeight: 600,
    textTransform: 'none' as const,
  },
  caption: {
    fontFamily: sharedFontFamily,
    textAlign: 'right' as const,
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '18px',
    letterSpacing: 0,
  },
  overline: {
    fontFamily: sharedFontFamily,
    fontSize: '0.75rem',
    fontWeight: 600,
    letterSpacing: 1.1,
    textTransform: 'uppercase' as const,
  },
};
